const elms = document.querySelectorAll('.wp-block-dunesblocks-expandable-section');
elms.forEach((elm) => {
	elm.addEventListener('click', ()=> {
		elm.classList.toggle('expanded');
	});
})
